"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataOfReasonableSize = exports.getHighchartsOptions = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var commonConfiguration_1 = require("./commonConfiguration");
var common_1 = require("../_util/common");
var lineConfiguration_1 = require("../lineChart/lineConfiguration");
var barConfiguration_1 = require("../barChart/barConfiguration");
var bulletConfiguration_1 = require("../bulletChart/bulletConfiguration");
var columnConfiguration_1 = require("../columnChart/columnConfiguration");
var customConfiguration_1 = require("./customConfiguration");
var pieConfiguration_1 = require("../pieChart/pieConfiguration");
var donutConfiguration_1 = require("../donutChart/donutConfiguration");
var areaConfiguration_1 = require("../areaChart/areaConfiguration");
var scatterConfiguration_1 = require("../scatterPlot/scatterConfiguration");
var comboConfiguration_1 = require("../comboChart/comboConfiguration");
var treemapConfiguration_1 = require("../treemap/treemapConfiguration");
var funnelConfiguration_1 = require("../funnelChart/funnelConfiguration");
var heatmapConfiguration_1 = require("../heatmap/heatmapConfiguration");
var bubbleConfiguration_1 = require("../bubbleChart/bubbleConfiguration");
var chartConfigurationMap = (_a = {},
    _a[sdk_ui_1.VisualizationTypes.LINE] = lineConfiguration_1.getLineConfiguration,
    _a[sdk_ui_1.VisualizationTypes.BAR] = barConfiguration_1.getBarConfiguration,
    _a[sdk_ui_1.VisualizationTypes.BULLET] = bulletConfiguration_1.getBulletConfiguration,
    _a[sdk_ui_1.VisualizationTypes.COLUMN] = columnConfiguration_1.getColumnConfiguration,
    _a[sdk_ui_1.VisualizationTypes.PIE] = pieConfiguration_1.getPieConfiguration,
    _a[sdk_ui_1.VisualizationTypes.AREA] = areaConfiguration_1.getAreaConfiguration,
    _a[sdk_ui_1.VisualizationTypes.SCATTER] = scatterConfiguration_1.getScatterConfiguration,
    _a[sdk_ui_1.VisualizationTypes.COMBO] = comboConfiguration_1.getComboConfiguration,
    _a[sdk_ui_1.VisualizationTypes.COMBO2] = comboConfiguration_1.getComboConfiguration,
    _a[sdk_ui_1.VisualizationTypes.TREEMAP] = treemapConfiguration_1.getTreemapConfiguration,
    _a[sdk_ui_1.VisualizationTypes.DONUT] = donutConfiguration_1.getDonutConfiguration,
    _a[sdk_ui_1.VisualizationTypes.FUNNEL] = funnelConfiguration_1.getFunnelConfiguration,
    _a[sdk_ui_1.VisualizationTypes.HEATMAP] = heatmapConfiguration_1.getHeatmapConfiguration,
    _a[sdk_ui_1.VisualizationTypes.BUBBLE] = bubbleConfiguration_1.getBubbleConfiguration,
    _a);
function getHighchartsOptions(chartOptions, drillConfig, config, definition, intl, theme) {
    var getConfigurationByType = chartConfigurationMap[chartOptions.type];
    ts_invariant_1.default(getConfigurationByType, "visualisation type " + chartOptions.type + " is invalid (valid types: " + common_1.stringifyChartTypes() + ").");
    return merge_1.default({}, commonConfiguration_1.getCommonConfiguration(chartOptions, drillConfig, theme), getConfigurationByType.call(null, config, definition, theme), customConfiguration_1.getCustomizedConfiguration(chartOptions, config, drillConfig, intl, theme));
}
exports.getHighchartsOptions = getHighchartsOptions;
function isDataOfReasonableSize(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
chartData, limits, isViewByTwoAttributes) {
    if (isViewByTwoAttributes === void 0) { isViewByTwoAttributes = false; }
    var result = true;
    var seriesLimit = limits === null || limits === void 0 ? void 0 : limits.series;
    if (seriesLimit !== undefined) {
        result = result && chartData.series.length <= seriesLimit;
    }
    var categoriesLimit = limits === null || limits === void 0 ? void 0 : limits.categories;
    if (categoriesLimit !== undefined) {
        if (isViewByTwoAttributes) {
            var categoriesLength = chartData.categories.reduce(function (result, category) {
                return result + category.categories.length;
            }, 0);
            result = result && categoriesLength <= categoriesLimit;
        }
        else {
            result = result && chartData.categories.length <= categoriesLimit;
        }
    }
    var dataPointsLimit = limits === null || limits === void 0 ? void 0 : limits.dataPoints;
    if (dataPointsLimit !== undefined) {
        result = result && chartData.series.every(function (serie) { return serie.data.length <= dataPointsLimit; });
    }
    return result;
}
exports.isDataOfReasonableSize = isDataOfReasonableSize;
//# sourceMappingURL=highChartsCreators.js.map